export default "__VITE_ASSET__DStjShEC__"